import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companies: [],
  catalog: [],
  commodities: [],
  tests: [],
};

const packageAddSlice = createSlice({
  name: "packageAdd",
  initialState,
  reducers: {
    fetchCompanies(state, action) {
      state.loading = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.companies = action.payload.data.document;
      state.loading = false;
    },
    fetchCompaniesFailure(state, action) {
      state.loading = false;
    },
    fetchCatalog(state, action) {
      state.loading = true;
    },
    fetchCatalogSuccess(state, action) {
      state.catalog = action.payload.data.document;
      state.loading = false;
    },
    fetchCatalogFailure(state, action) {
      state.loading = false;
    },
    fetchCommodities(state, action) {
      state.loading = true;
      state.commodities = [];
    },
    fetchCommoditiesSuccess(state, action) {
      state.loading = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.loading = false;
    },
    fetchTests(state, action) {
      state.loading = true;
      state.tests = [];
    },
    fetchTestsSuccess(state, action) {
      state.loading = false;
      state.tests = action.payload.data.document;
    },
    fetchTestsFailure(state, action) {
      state.loading = false;
    },
    createPackage(state, action) {
      state.loading = true;
    },
    createPackageSuccess(state, action) {
      state.loading = false;
    },
    createPackageFailure(state, action) {
      state.loading = false;
      state.error = action.payload?.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.companies = [];
      state.catalog = [];
      state.commodities = [];
      state.tests = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = packageAddSlice;
